import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store/index.js'
import { setToken, getToken, canTurnTo, setTitle } from '@/libs/util'

Vue.use(Router)

const router = new Router({
  routes,
})
const TurnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) next() // 有权限，可访问
  else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
}
 
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const LOGIN_PAGE_NAME = 'login'

router.beforeEach(function(to, from, next) {

  store.commit('updateLoadingStatus', { isLoading: true })

  const token = getToken()
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: 'home' // 跳转到homeName页
    })
  } else {
    if (store.state.user.hasGetInfo) {
      TurnTo(to, store.state.user.access, next)
    } else {
      store.dispatch('getUserInfo').then(user => {
        // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
        TurnTo(to, user.access, next)
      }).catch(() => {
        setToken('')
        next({
          name: 'login'
        })
      })
    }
  }
})

router.afterEach(function(to) {
  setTitle(to, router.app)
  store.commit('updateLoadingStatus', { isLoading: false })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js